function init() {

  window.cookieconsent.initialise({
      "palette": {
        "popup": {
          "background": "#ffffff",
          "text": "#04127E"
        },
        "button": {
          "background": "#04127E",
          "text": "#ffffff"
        }
      },
      "theme": "classic",
      "target": '_blank',
      "type": "opt-out",
      "content": {
        "dismiss": "Accept",
        "deny": "Reject",
        "href": "/privacy-policy"
      },
      onInitialise: function (status) {
          var type = this.options.type;
          var didConsent = this.hasConsented();
          if (type == 'opt-in' && didConsent) {
              // Enabled
              window['ga-disable-UA-173068616-1'] = false;
          }
          if (type == 'opt-out' && !didConsent) {
              // Disabled
              window['ga-disable-UA-173068616-1'] = true;
          }
      },
      onStatusChange: function(status, chosenBefore) {
          var type = this.options.type;
          var didConsent = this.hasConsented();
          if (type == 'opt-in' && didConsent) {
              // Enabled
              window['ga-disable-UA-173068616-1'] = false;
          }
          if (type == 'opt-out' && !didConsent) {
              // Disabled
              window['ga-disable-UA-173068616-1'] = true;
          }
      },
      onRevokeChoice: function() {
          var type = this.options.type;
          if (type == 'opt-in') {
              // Disabled
              window['ga-disable-UA-173068616-1'] = true;
          }
          if (type == 'opt-out') {
              // Enabled
              window['ga-disable-UA-173068616-1'] = false;
          }
      }
  });

}

export default init;

/*
function init() {

  window.cookieconsent.initialise({
      type   : "categories",
      header: 'Cookies used on the website!',
      message: 'Like most websites we use cookies to deliver a personalised service. To use the website as intended please accept cookies.',
      dismiss: 'Accept',
      allow: 'Allow cookies',
      deny: 'Decline',
      link: 'Learn more',
      href: 'https://www.britishskinfoundation.org.uk/privacy-policy',
      close: '&#x274c;',
      policy: 'Cookie Policy',
      target: '_blank',
  });

  function pushDown(height) {
      var navbar = document.getElementsByClassName(" NAVBAR CLASS ")[0];
      navbar.style.transition = 'all 1s';
      navbar.style.marginTop = height+'px';
  }

}

export default init;
*/
